'use strict';

define([], function () {
    function Controller(__env, $mdMedia, $scope, isTrialing, $rootScope, $state, SuiteNavigation, UserService,
                        currentUser, AuthService, stAcceptanceService, $filter, $window, LanguageService, $location, $localStorage, PlanDetailsService, userInfo, subscriptions) {
        var vm = $scope;
        vm.navigation = SuiteNavigation.state;
        /* The main navigation starts collapsed so the workspace is immediately usable. */
        vm.suiteNavCompact = true;
        vm.closeSidebar = SuiteNavigation.close;
        vm.languageName = LanguageService.getLanguageName;
        vm.$mdMedia=$mdMedia;
        /* Settings has many entries and needs readable labels, so it always opens
           the expanded desktop navigation. Other tools keep the compact rail. */
        function syncNavigationLayout() {
            if (!$mdMedia('gt-sm')) {
                vm.suiteNavCompact = false;
                return;
            }
            vm.suiteNavCompact = !$state.includes('app.settings');
        }
        syncNavigationLayout();
        vm.$watch(function () { return $mdMedia('gt-sm'); }, function (desktop) {
            syncNavigationLayout();
            if (desktop) {
                SuiteNavigation.close();
            }
        });
        vm.$on('$stateChangeSuccess', syncNavigationLayout);
        vm.isTrialing = isTrialing;
        vm.isNotInTrial = true;
        vm.isAuth = AuthService.isAuthenticated();
        vm.currentUser = currentUser;
        vm.accountPitchground = false;
        vm.isPromoTime = PlanDetailsService.isPromoTime();
        if (vm.isPromoTime) {
            vm.currentPromo = PlanDetailsService.getCurrentPromo();
        }
        vm.isOffline = vm.currentUser === false;
        vm.suiteSection = function () {
            var tool = $state.current.name.split('.')[1];
            if (['seochecker', 'seospider', 'backlinkchecker'].indexOf(tool) !== -1) return 'audit';
            if (['keywordexplorer', 'keywordlistmanager', 'serpchecker', 'googleads'].indexOf(tool) !== -1) return 'research';
            if (['writerassistant', 'writeassistance', 'seoeditor', 'copymetrics'].indexOf(tool) !== -1) return 'content';
            if (tool === 'leadgeneration') return 'leads';
            if (tool === 'settings') return 'settings';
            return 'projects';
        };
        vm.suiteSectionTitle = function () {
            return 'suite.nav.' + vm.suiteSection();
        };
        vm.isProjectWorkspace = function () {
            return $state.includes('app.project');
        };
        vm.isProjectWizard = function () {
            return $state.includes('app.project.wizard');
        };
        vm.isSeoChecker = function () {
            return $state.includes('app.seochecker');
        };
        vm.isToolLanding = function () {
            var state = $state.current.name || '';
            if (/\.landing$/.test(state) || state === 'app.keywordexplorer.search') {
                return true;
            }
            if (state === 'app.serpchecker.tool.benchmark.backlink' && !$state.params.keyword) {
                return true;
            }
            return state === 'app.backlinkchecker.tool' && !$state.params.domain;
        };
        vm.suiteSectionRoute = function (section) {
            var routes = section === 'audit' ? [
                ['seo_checker_edit', 'app.seochecker.landing'], ['project_read', 'app.seospider.list']
            ] : [
                ['editor_read', 'app.writerassistant.landing'], ['copy_metrics_edit', 'app.copymetrics.landing']
            ];
            var user = $localStorage.currentUser || currentUser;
            var permissions = user && user.workspace && user.workspace.permissions;
            var route = routes.filter(function (item) {
                return !permissions || permissions.indexOf(item[0]) !== -1;
            })[0];
            return (route || routes[0])[1];
        };
        vm.suitePageTitle = function () {
            var state = $state.current.name;
            var pages = {
                welcome: 'Dashboard', seochecker: 'SEO Checker', seospider: 'SEO Spider',
                keywordexplorer: 'Keyword Explorer',
                keywordlistmanager: 'Keyword Manager', googleads: 'Keyword Planner',
                serpchecker: 'SERP Checker', writerassistant: 'Writer Assistant AI',
                writeassistance: 'SEO Editor', seoeditor: 'SEO Editor', copymetrics: 'Copy Metrics',
                backlinkchecker: 'Backlink Checker', leadgeneration: 'Lead Generation',
                project: 'project.your.project', settings: 'Settings'
            };
            var key = state.split('.')[1];
            return pages[key] || 'SEO Tester Online';
        };

        vm.shouldShowWorkspaceNavbar=shouldShowWorkspaceNavbar;
        function shouldShowWorkspaceNavbar(){
            if($state.current.name.match('app.serpchecker.tool.benchmark')&&!$state.params.keyword){
                return true;
            }
            return ['app.seospider.landing',
                'app.seospider.list',
                'app.seochecker.landing',
                'app.welcome',
                'app.keywordlistmanager.landing',
                'app.keywordlistmanager.list',
                'app.keywordlistmanager.v2',
                'app.writeassistance.landing',
                'app.seoeditor.landing',
                'app.copymetrics.landing',
                'app.leadgeneration.landing'].indexOf($state.current.name) !== -1;

        }
        /*

        const st = {
            "businessType": "Freelance",
            "email": "admin@admin.com",
            "firstname": "Vittorio",
            "id": 1,
            "jobTitle": "CEO/Founder",
            "lastname": "Inzaghio",
            "locale": "en-US",
            "stripeCustomerId": "cus_J2afRJBB96bXOr",
            "teamMembers": "6-10",
            "type": "agency",
            "uuid": "28e4a07c-7501-11eb-a96e-069239494043",
            "verified": 1,
            "profileImgUrl": "https://stouserimage.s3.eu-west-1.amazonaws.com/sto-user-image-f3790d85d824c1074d8e3635d768b03a.png",
            "workspace": {
                "id": 1,
                "ownerId": 1,
                "name": "Stark Industries",
                "logoImgUrl": "https://stouserimage.s3.eu-west-1.amazonaws.com/sto-user-image-e1eb1903d77cb6f764fa4b995d399b56.png",
                "createdAt": "2021-02-22T11:29:00.000Z",
                "updatedAt": "2023-11-08T10:03:41.000Z",
                "deletedAt": null,
                "members": 1,
                "permissions": ["project_read", "project_edit", "keyword_list_read", "keyword_list_edit", "seo_checker_edit", "keyword_explorer_edit", "serp_checker_edit", "copy_metrics_edit", "editor_read", "editor_edit", "lead_gen_read", "lead_gen_edit", "report_read", "report_edit", "workspace_edit", "workspace_user_admin", "workspace_user_manager", "workspace_user_bookkeeper", "workspace_user_marketer", "workspace_user_client", "workspace_invoice_read", "workspace_invoice_edit", "workspace_log_read", "workspace_partner_program_read", "workspace_partner_program_edit", "workspace_payment_methods_read", "workspace_subscriptions_read"],
                "roleId": 1,
                "roleName": "owner",
                "ownerEmail": "admin@admin.com"
            }
        };

        */
        //Set Language and Country get from Storage or set from default config
        vm.selectedLang = LanguageService.getCodeAndCountrySaveOnStorage();
        vm.isItalianLanguage = false;
        vm.toggleSidebar = toggleSidebar;
        vm.switchLang = switchLang;
        vm.userPlan = userPlan;
        vm.location = $location;
        vm.workspace = [];
        vm.goToPromoLink = goToPromoLink;
        vm.closeSeasonPromoBanner = closeSeasonPromoBanner;
        vm.updateSeasonPromoPreference = updateSeasonPromoPreference;
        vm.userHasAnActiveSubscription = userHasAnActiveSubscription;
        vm.userInfo = userInfo;
        vm.subscriptions = Array.isArray(subscriptions) ? subscriptions : [];
        vm.hasSubscriptionData = !vm.isAuth
            || Array.isArray(subscriptions)
            || !!(vm.currentUser && Array.isArray(vm.currentUser.subscriptions));
        vm.monthlyPlans = [];
        vm.annualPlans = [];
        vm.userHasAnAnnualPlanLiteActive = false;
        vm.canDismissSeasonPromo = false;
        vm.seasonPromoDontShowAgain = false;
        vm.seasonPromoDismissKey = '';
        vm.isItalianLanguage = vm.selectedLang === 'it-IT';
        refreshSeasonPromoBanner();


        vm.$watch(function () {
            return localStorage.getItem('NG_TRANSLATE_LANG_KEY');
        }, function (currentLanguage, previousLanguage) {

            vm.isItalianLanguage = currentLanguage === 'it-IT';
            refreshSeasonPromoBanner();
        });

        function getActiveSubscriptions(currentUser) {
            var subscriptionList = vm.subscriptions.length
                ? vm.subscriptions
                : (currentUser && currentUser.subscriptions || []);
            return subscriptionList.filter(function (subscription) {
                var statusIsActive = subscription.status === 'active';
                var stillActive = !subscription.currentPeriodEnd
                    || new Date(subscription.currentPeriodEnd) >= new Date();
                return statusIsActive && stillActive;
            });
        }

        function subscriptionHasMonthlyPlan(subscription) {
            return (subscription.plans || []).some(function (plan) {
                return plan.interval === 'month'
                    || /month|mensil|monthly/i.test(plan.alias || plan.name || '');
            });
        }

        function subscriptionHasRenewalDisabled(subscription) {
            return Number(subscription.cancelAtPeriodEnd) > 0
                || Number(subscription.removedFromGateway) > 0
                || subscription.renewal === false;
        }

        function promotionIsVisibleForLanguage() {
            if (!vm.currentPromo || !vm.currentPromo.languageVisibility) {
                return false;
            }
            return vm.currentPromo.languageVisibility === 'all'
                || (vm.currentPromo.languageVisibility === 'it' && vm.isItalianLanguage);
        }

        function getSeasonPromoDismissKey() {
            if (!vm.currentPromo) {
                return '';
            }
            var userKey = vm.currentUser && (vm.currentUser.email || vm.currentUser.id) || 'guest';
            var year = vm.currentPromo.startPromoDate
                ? new Date(vm.currentPromo.startPromoDate).getFullYear()
                : new Date().getFullYear();
            return 'seasonPromoDialogDontShowAgain:v2:' + userKey + ':' + vm.currentPromo.id + ':' + year;
        }

        function refreshSeasonPromoBanner() {
            if (!vm.hasSubscriptionData) {
                vm.userCanSeePromotion = false;
                vm.userCanSeePromoPricing = false;
                vm.canDismissSeasonPromo = false;
                return;
            }
            var activeSubscriptions = getActiveSubscriptions(vm.userInfo);
            var hasActiveSubscription = activeSubscriptions.length > 0;
            var hasMonthlySubscription = activeSubscriptions.some(subscriptionHasMonthlyPlan);
            var hasRenewalDisabled = activeSubscriptions.some(subscriptionHasRenewalDisabled);
            var promoId = vm.currentPromo && vm.currentPromo.id;
            var isMonthlyPromoWindow = promoId === 'black' || promoId === 'cyber';

            vm.userHasAnActiveSubscription(vm.userInfo);
            vm.seasonPromoDismissKey = getSeasonPromoDismissKey();

            var eligibleForPromo = vm.isPromoTime
                && promotionIsVisibleForLanguage()
                && (
                    vm.isOffline
                    || !hasActiveSubscription
                    || hasRenewalDisabled
                    || (hasMonthlySubscription && isMonthlyPromoWindow)
                );
            if (!eligibleForPromo) {
                vm.userCanSeePromotion = false;
                vm.userCanSeePromoPricing = false;
                vm.canDismissSeasonPromo = false;
                vm.seasonPromoDontShowAgain = false;
                return;
            }

            vm.userCanSeePromoPricing = true;
            vm.canDismissSeasonPromo = true;
            var wasDismissed = false;
            if (vm.seasonPromoDismissKey) {
                try {
                    wasDismissed = localStorage.getItem(vm.seasonPromoDismissKey) === '1';
                } catch (error) {
                    wasDismissed = false;
                }
            }
            vm.seasonPromoDontShowAgain = wasDismissed;
            vm.userCanSeePromotion = !wasDismissed;
        }

        function closeSeasonPromoBanner() {
            updateSeasonPromoPreference();
            vm.userCanSeePromotion = false;
        }

        function updateSeasonPromoPreference() {
            if (!vm.seasonPromoDismissKey) {
                return;
            }
            try {
                if (vm.seasonPromoDontShowAgain) {
                    localStorage.setItem(vm.seasonPromoDismissKey, '1');
                } else {
                    localStorage.removeItem(vm.seasonPromoDismissKey);
                }
            } catch (error) {
                // The dialog still remains dismissible for the current view.
            }
        }

        function userHasAnActiveSubscription(currentUser) {
            var subscriptions = getActiveSubscriptions(currentUser);
            vm.monthlyPlans = [];
            vm.annualPlans = [];
            vm.userHasAnAnnualPlanLiteActive = false;
            subscriptions.forEach(function (subscription) {
                (subscription.plans || []).forEach(function (plan) {
                    if (plan.interval === 'month') {
                        vm.monthlyPlans.push(plan);
                    } else if (plan.interval === 'year') {
                        if (plan.alias === 'plan-lite-annual') {
                            vm.userHasAnAnnualPlanLiteActive = true;
                        }
                        vm.annualPlans.push(plan);
                    }
                });
            });
            return subscriptions.length > 0;
        }

        function goToPromoLink() {
            if (vm.currentPromo.bannerCTALink) {
                $window.open(vm.currentPromo.bannerCTALink + '&utm_medium=topbar', '_blank');
                return;
            }

            $state.go('upgrade.choose-plan');
        }

        //show button-bottom on mobile
        function userPlan() {
            return !vm.isAuth;
        }

        vm.isNotEasterEegNav = isNotEasterEegNav;

        function isNotEasterEegNav(currentUser) {
            return currentUser.email != 'v.urzi@seotesteronline.com' &&
                currentUser.email != 'g.sciuto@seotesteronline.com';
        }

        if (vm.isAuth) {
            UserService.accountInfo()
                .then(function (res) {
                    if ((new Date(res.data.acceptedPrivacyPolicyAt).getTime() < __env.privacyPolicy) ||
                        (new Date(res.data.acceptedCookiePolicyAt).getTime() < __env.cookiePolicy) ||
                        (new Date(res.data.acceptedDataProcessingAgreementAt).getTime() < __env.dataProcessingAgreement) ||
                        (new Date(res.data.acceptedTermsAndConditionsAt).getTime() < __env.termsAndConditions)) {
                        stAcceptanceService.open();
                    }
                    if ($filter('date')(new Date(res.data.lastLogin).getTime(), 'yyyy-MM-dd') != $filter('date')(new Date().getTime(), 'yyyy-MM-dd')) {
                        UserService.updateProfile({
                            lastLogin: $filter('date')(new Date().getTime(), 'yyyy-MM-dd HH:mm:ss')
                        });
                    }
                });
        }

        vm.$watchCollection('$state', function () {
            if ($state.current.name)
                vm.source = $state.current.name.replace('app.', '').replace(/\..*/gi, '').toLowerCase();
            else vm.source = 'not-specified';
        });

        function toggleSidebar() {
            SuiteNavigation.toggle();
        }

        // It Called only when we are on sidebar-expandend
        function switchLang(language) {
            vm.selectedLang = language;

            try {
                $rootScope.setLang(language)
                    .catch(function (error) {
                        console.log(error);
                    });
            } catch (e) {
                console.log(e);
            }

            if (AuthService.isAuthenticated()) {
                UserService.updateProfile({
                    locale: language
                })
                    .then(function (res) {
                    })
                    .catch(function (err) {
                        console.log(err);
                    });
            }
        }

        vm.onSwipeLeft = function () {
            SuiteNavigation.close();
        };

        vm.logout = function () {
            AuthService.logout();
            setTimeout(function () {
                $state.go('app.welcome', {}, {
                    reload: true
                });
            }, 1000);
        };

        vm.$on("switchWorkSpace", function (evt) {
            vm.currentUser = $localStorage.currentUser;
        });

        vm.ecf = $window.localStorage.getItem('ecf') ? false : true;

        vm.setEcf = function () {
            vm.ecf = false;
            $window.localStorage.setItem('ecf', 'true');
        };
    }

    Controller.$inject = ['__env', '$mdMedia','$scope', 'isTrialing', '$rootScope', '$state', 'SuiteNavigation', 'UserService', 'currentUser', 'AuthService', 'stAcceptanceService', '$filter',
        '$window', 'LanguageService', '$location', '$localStorage', 'PlanDetailsService', 'userInfo', 'subscriptions'
    ];
    return Controller;
});
